module.exports = __webpack_public_path__ + "img/b_20.fc45be56.jpg";